import { useModulePermission } from '@sdx/b2o-fe-tools';
import type { ModuleName } from '@sdx/b2o-fe-tools';

type UsePasPermissionProps = {
  accessToken: string | null;
  baseUrl: string;
  siteCode?: string;
};

type PasPermissionState = {
  isChecking: boolean;
  hasAccess: boolean | null;
};

const PAS_MODULE: ModuleName = 'pas';

export const usePasPermission = ({
  accessToken,
  baseUrl,
  siteCode,
}: UsePasPermissionProps): PasPermissionState => {
  const { permissions, isLoading, hasError, canExecute } = useModulePermission(PAS_MODULE, {
    baseUrl,
    accessToken: accessToken ?? undefined,
    siteCode: siteCode ?? undefined,
  });

  if (!canExecute || isLoading) {
    return { isChecking: true, hasAccess: null };
  }

  if (hasError || !permissions) {
    return { isChecking: false, hasAccess: false };
  }

  return { isChecking: false, hasAccess: permissions.canRead };
};
